import { createSlice } from "@reduxjs/toolkit";
import {
	setAccount_,
	removeAccount_,
	getAccount_,
} from "../../lib/useLocalStorageAccount";

const accountDetails = getAccount_();

const accountSlice = createSlice({
	name: "account",
	initialState: accountDetails ? accountDetails : null,
	reducers: {
		getAccount(state) {
			const accountData = getAccount_();
			return { ...state, ...accountData };
		},
		setAccount(state, action) {
			const accountData = { ...state, ...action.payload };
			setAccount_(accountData);
			return accountData;
		},
		resetAccount(state, action) {
			removeAccount_();
			return null;
		},
	},
});

export const { getAccount, setAccount, resetAccount } = accountSlice.actions;

export default accountSlice.reducer;
